module.exports = __webpack_public_path__ + "img/logo-white-bg.2727c5e1.svg";